/* global */

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'featured_card_handler';
export let global_vars = {};

// Local imports
import {
    postGiftToCart,
    updateAddButtonStatus,
} from '../../util/postFeaturedGift.js';

// Add click listeners to the add buttons in the featured gift cards
function init_featured_cards_listeners(global) {
    let all_featured = global.document.querySelectorAll(
        'div.card--featuredproduct'
    );

    for (let card of all_featured) {
        let cardnum = card.dataset.cardnum;
        let button_id = `buttonid${cardnum}`;
        let button = global.document.querySelector(`#${button_id}`);
        if (!button) {
            continue;
        }
        updateAddButtonStatus(global, cardnum);

        button.addEventListener('click', event => {
            if (!button.classList.contains('button--disabled')) {
                event.preventDefault();
                on_featured_card_add_clicked(global, cardnum);
            }
        });

        init_featured_cards_select_listener(global, cardnum);
    }
}

function on_featured_card_add_clicked(global, cardnum) {
    let form = global.document.getElementById(`form${cardnum}`);
    postGiftToCart(global, form, cardnum);
}

function init_featured_cards_select_listener(global, cardnum) {
    let variantSelect = global.document.getElementById(`variantid${cardnum}`);
    if (!variantSelect) {
        return;
    }
    variantSelect.addEventListener('change', () => {
        updateAddButtonStatus(global, cardnum);
    });
}

export function initialize(global) {
    init_featured_cards_listeners(global);
}
